module.exports = __webpack_public_path__ + "static/media/school.ce3e4cb9.png";